import * as React from 'react';

import InventoryImage from './InventoryImage';

export default function TableThumbnail({ size = 42, sx = {}, ...props }) {
  return (
    <InventoryImage
      {...props}
      height={size}
      sx={{
        width: size,
        flexShrink: 0,
        borderRadius: '9px',
        ...sx,
      }}
    />
  );
}
